import { render, staticRenderFns } from "./EmptyRoom.vue?vue&type=template&id=686bf702&"
import script from "./EmptyRoom.vue?vue&type=script&lang=js&"
export * from "./EmptyRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports